import { EndEventCell } from "@edp-pmf/grapheditor";
import { BpmnModelHelper, EndEvent, FlowNodeState } from "@edp-pmf/bpmn-model";
import { WfConstants } from "../WfConstants";

/**
 * 结束事件节点，增加状态图片信息
 */
export class WfEndEventCell extends EndEventCell {
    imgUrls = {
        [FlowNodeState.Default]: WfConstants.IMAGE_PATH + "/end.png",
        [FlowNodeState.Selected]: WfConstants.IMAGE_PATH + "/end_select.svg",
    };

    createFlowElement(flowElt?: EndEvent) {
        const flowNode = super.createFlowElement(flowElt) as EndEvent;
        flowNode.Id = "EndEvent" + BpmnModelHelper.GenerateElementId();

        return flowNode;
    }
}